import { useRemoteConfig } from '@/modules/remote-config'
import { Alert } from 'react-native'

export const showMaintenanceModeAlert = () => {
  const { title, message } = useRemoteConfig.getState().maintenance_mode
  Alert.alert(title, message, [{ text: 'OK' }])
}

export function isMaintenanceModeEnabled() {
  return useRemoteConfig.getState().maintenance_mode.enabled
}
